export default __webpack_public_path__ + "static/media/service1.5253c0a5.png";